module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-lock-27adc69d.svg";